'use strict';

angular.module('app.notification', [])

.controller('NotificationCtrl', function ($scope, $modal, $http, $rootScope, $window, adminService) {
    
    $scope.preloadData = false;
    $scope.currentUser = $rootScope.currentUser;

    $scope.influencerGroupList = [
        {id: 1, name: 'Influencer Group 1'},
        {id: 2, name: 'Influencer Group 2'},
        {id: 3, name: 'Influencer Group 3'},
        {id: 4, name: 'Influencer Group 4'}
    ];

    $scope.minimumImpactList = [
        {id: 2, value: 25},
        {id: 2, value: 50},
        {id: 2, value: 75},
        {id: 2, value: 100},
        {id: 2, value: 125},
        {id: 2, value: 150},
        {id: 2, value: 175},
        {id: 2, value: 200}
    ];

    $scope.minimumEngagementList = [
        {id: 2, value: 1000},
        {id: 2, value: 2000},
        {id: 2, value: 3000},
        {id: 2, value: 4000},
        {id: 2, value: 5000},
        {id: 2, value: 10000},
        {id: 2, value: 15000},
        {id: 2, value: 20000},
        {id: 2, value: 30000},
        {id: 2, value: 40000},
        {id: 2, value: 50000},
        {id: 2, value: 75000},
        {id: 2, value: 100000}
    ];

    $scope.minimumReachList = [
        {id: 2, value: 1000},
        {id: 2, value: 2000},
        {id: 2, value: 3000},
        {id: 2, value: 4000},
        {id: 2, value: 5000},
        {id: 2, value: 10000},
        {id: 2, value: 15000},
        {id: 2, value: 20000},
        {id: 2, value: 30000},
        {id: 2, value: 40000},
        {id: 2, value: 50000},
        {id: 2, value: 75000},
        {id: 2, value: 100000}
    ];

    var currentLoggedInUser = {
        id: 0,
        name: $scope.currentUser.firstName + ' ' + $scope.currentUser.lastName,
        ticked: true
    }

    $scope.selectedAdvertiser = 0;

    $scope.advertiserList = [];
    $scope.advertiserList.push(currentLoggedInUser);
    var url = $rootScope.apiUrl + 'admin/GetAllAdvertiser';
    $http.get(url, {loader: false}).
        success(function (response) {
            angular.forEach(response.data, function(item) {
                $scope.advertiserList.push(item);
            })
        }).error(function (response) {
            $scope.advertiserList = [];
        });

    $scope.searchAdvertisers = function(event) {
        if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
            for(var i = 1; i < $scope.advertiserList.length; i++) {
                if($scope.advertiserList[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                    var checkbox = $("#selectedAdvertiser > .checkboxLayer.show .checkBoxContainer")
                    var item = checkbox.find('label')[i];
                    checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                    break;
                }
            }
        }
    }

    $scope.loadData = function(param){
        $scope.preloadData = true;

        var req = {
            url: $rootScope.apiUrl + 'notification/getNotificationList',
            method: 'POST',
            data: JSON.stringify(param)
        } 
        
        $http(req).success(function (responseNotificationList) {
            $scope.notificationList = responseNotificationList.data;
        }) .error(function (data) {

        }); 
    }

    $scope.$watch('newSelectedAdvertiser', function(newValue, oldValue) {
        if(newValue && oldValue && newValue[0].id != oldValue[0].id) {
            $scope.selectedAdvertiser = newValue[0].id;
            var param = {
                advertiser: $scope.selectedAdvertiser
            }

            $scope.preLoaded = true;
            $scope.loadData(param);
        }
    })

    if($scope.preloadData == false){
        var param = {
            advertiser: $scope.selectedAdvertiser
        }
        $scope.loadData(param);
    }

    $scope.newNotificationModalHandler = function () {
        var notificationModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/notification/partials/notificationDetail.html?app_v=deployDate',
            controller: 'NewNotificationCtrl'
        });

        $scope.selectedAdvertiser;
        $scope.modalInstance = notificationModalInstance;
        $scope.newMinReachList = $scope.minimumReachList;
        $scope.newMinEngagementList = $scope.minimumEngagementList;
        $scope.newMinImpactList = $scope.minimumImpactList;
        $scope.newInfluencerGroupList = $scope.influencerGroupList;
    };

    $scope.removeNotification = function(notificationId){
        var req = {
            url: $rootScope.apiUrl + 'notification/deleteNotification/' + notificationId,
            method: 'DELETE'
        }

        $http(req).success(function (responseDeleteNotification) {
            var param = {
                advertiser: $scope.selectedAdvertiser
            }
            $scope.loadData(param);
        })
        .error(function (data) {

        });
    }

    $scope.editNotificationModalHandler = function(notificationId){
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/notification/partials/notificationDetail.html?app_v=deployDate',
            controller: 'NotificationDetailCtrl',
        });
        
        $scope.selectedAdvertiser;
        $scope.notificationId = notificationId;
        $scope.editMinReachList = $scope.minimumReachList;
        $scope.editMinEngagementList = $scope.minimumEngagementList;
        $scope.editMinImpactList = $scope.minimumImpactList;
        $scope.editInfluencerGroupList = $scope.influencerGroupList;
    }
})

.controller('NewNotificationCtrl', function ($scope, $modal, $http, $rootScope, $window, adminService, $modalInstance, TRACK_EVENTS) {    
    $scope.isNewNotification = true;
    $scope.notificationTypeDescription = "";
    $scope.selectedNotificationTypeId = 0;
    $scope.selectedRow = null;
    $scope.selectedOption = 0;
    $scope.condition = null;
    $scope.reload = false;
    $scope.countAddedCondition = 0;
    $scope.editRow = true;
    $scope.addNewCondition = true;
    $scope.notificationName = null;
    $scope.selectedOption = 0;
    $scope.selectedRow = 0;
    $scope.preloadData = true;

    if($scope.selectedAdvertiser != 0) {
        var url = $rootScope.apiUrl + 'notification/getUserByCompany/' + $scope.selectedAdvertiser;
        $http.get(url, {loader: false}).
            success(function (response) {
                $scope.userList = response.data;
            }).error(function (response) {
                $scope.userList = [];
            });
    } 

    var getNotificationTypeUrl = $rootScope.apiUrl + 'notification/getNotificationType';
    $http.get(getNotificationTypeUrl, {loader: false})
    .success(function(responseGetNotificationType){
        $scope.notificationType = responseGetNotificationType.data;

        ////notification for custom report///
        if($scope.isCustomReport == true)
        {
            $scope.notificationType[0].ticked = true;
            $scope.selectNotificationType($scope.notificationType[0]);
        }

    });

    $scope.influencerGroupList = $scope.newInfluencerGroupList;

    $scope.minimumImpactList = $scope.newMinImpactList;

    $scope.minimumEngagementList = $scope.newMinEngagementList;

    $scope.minimumReachList = $scope.newMinReachList;

    $scope.cancelAddNewNotification = function() {
        $modalInstance.close();
    }

    $scope.selectNotificationType = function(data){
        $scope.notificationTypeDescription = "";
        if(data.id == 1){
            $scope.selectedNotificationTypeId = 1;
            $scope.notificationTypeDescription = 'Get weekly or monthly report on your project';
            var getReportTypeUrl = $rootScope.apiUrl + 'notification/getMeasureReportType/' + $scope.selectedAdvertiser;
            $http.get(getReportTypeUrl, {loader: false})
            .success(function(responseGetReportType){
                $scope.reportList = responseGetReportType.data;
                for(var i=0; i<$scope.reportList.length; i++) {
                    if($scope.reportList[i].id == $scope.selectedReport){ ////notification for custom report///
                        $scope.reportList[i].ticked = true;
                    }
                }

                var getNotificationFrequencyUrl = $rootScope.apiUrl + 'notification/getNotificationFrequency';
                $http.get(getNotificationFrequencyUrl, {loader: false})
                .success(function(responseGetNotificationFrequency){
                    $scope.notificationFrequencyList = responseGetNotificationFrequency.data;
                    $scope.notificationFrequencyList.splice(0,1);

                    var getNotificationProjectUrl = $rootScope.apiUrl + 'notification/getProject/' + $scope.selectedAdvertiser;
                    $http.get(getNotificationProjectUrl, {loader: false})
                    .success(function(responseGetNotificationProject){
                        $scope.projectList = responseGetNotificationProject.data;
                        $scope.projectList.forEach(function(project){
                            project.name = project.project_name;
                            ////notification for custom report///
                            if($scope.isCustomReport == true && project.id == $scope.currentProjectId)
                            {
                                project.ticked = true;
                            }
                        })

                    })
                });
            }); 
        } else if(data.id == 2){
            $scope.selectedNotificationTypeId = 2;
            $scope.notificationTypeDescription = 'Get notification when your brands get mentioned';
            var getNotificationProjectUrl = $rootScope.apiUrl + 'notification/getProject/' + $scope.selectedAdvertiser;
            $http.get(getNotificationProjectUrl, {loader: false})
            .success(function(responseGetNotificationProject){
                $scope.projectList = responseGetNotificationProject.data;
                $scope.projectList.forEach(function(project){
                    project.name = project.project_name;
                    ////notification for custom report///
                    if($scope.isCustomReport == true && project.id == $scope.currentProjectId)
                    {
                        project.ticked = true;
                    }
                })
                
            })
        } else if(data.id == 3){
            $scope.selectedNotificationTypeId = 3;
            $scope.notificationTypeDescription = 'Get notification for relevant influencers for your brand';
        }
    };

    $scope.setClickedRow = function(index){
        $scope.selectedRow = index;
    }

    $scope.selectCondition = function(option){ 
        $scope.selectedRow = null;       
        if(option == 'reach'){
            $scope.selectedOption = 1;
        } else if(option == 'engagement'){
            $scope.selectedOption = 2;
        } else if(option == 'impact'){
            $scope.selectedOption = 3;
        } else if(option == 'none'){
            $scope.selectedOption = 0;
        }
    }

    $scope.conditionListObject = [];

    $scope.addCondition = function(){
        var match = null;
        var conditionList = null;
        var newCondition = {};

        var getMatchUrl = $rootScope.apiUrl + 'notification/getMatch';
        $http.get(getMatchUrl, {loader: false})
        .success(function(responseGetMatch){
            newCondition.match = responseGetMatch.data;
            newCondition.match[0].ticked = true;

            var getConditionListUrl = $rootScope.apiUrl + 'notification/getConditionList';
            $http.get(getConditionListUrl, {loader: false})
            .success(function(responseGetConditionList){
                newCondition.conditionList = responseGetConditionList.data;
                $scope.conditionListObject.push(newCondition);
                $scope.reload = false;
                $scope.addNewCondition = true;
            });
        });                
    }

    $scope.removeCondition = function(index){
        $scope.conditionListObject.splice(index, 1);
        $scope.countAddedCondition = 0;
        $scope.reload = true;
        $scope.editRow = false;
        $scope.addNewCondition = false;
        $scope.enableWatch = true;
    }
    $scope.updateReload = function(){
        $scope.reload = !$scope.updateReload;
        $scope.enableWatch = false;
    }

    $scope.saveNewNotification = function(){
        $scope.selectedNotificationType = 0;
        $scope.selectedReport = null;
        $scope.selectedProject = null;
        $scope.selectedInfluencerGroup = null;
        $scope.selectedNotificationFrequency = null;
        $scope.selectedMinValue = 0;
        $scope.listOfConditions = [];

        angular.forEach($scope.notificationType, function(noType){
            if(noType.ticked == true){
                $scope.selectedNotificationType = noType.id;
            }
        })

        $scope.newNotificationData = {
            notificationName: $scope.notificationName,
            notificationType: $scope.selectedNotificationType
        };

        $scope.newNotificationData.selectedAdvertiser = $scope.selectedAdvertiser;
        if(($scope.currentUser.role.accessLevel == "admin") && $scope.newNotificationData.selectedAdvertiser != 0 && $scope.selectedUser.length > 0) {
            $scope.newNotificationData.selectedUser = $scope.selectedUser[0].id;
        }

        if ($scope.currentUser.role.accessLevel == "advertiser") {
            $scope.newNotificationData.selectedUser = $scope.currentUser.id;
        }

        if($scope.selectedNotificationType == 1){
            angular.forEach($scope.reportList, function(report){
                if(report.ticked == true){
                    $scope.selectedReport = report.id;
                }
            })

            angular.forEach($scope.projectList, function(project){
                if(project.ticked == true){
                    $scope.selectedProject = project.id;
                }
            })

            // Influencer Group is not a part of version 1 
            /*angular.forEach($scope.influencerGroupList, function(influencerGroup){
                if(influencerGroup.ticked == true){
                    selectedInfluencerGroup = influencerGroup.id;
                }
            })*/

            angular.forEach($scope.notificationFrequencyList, function(notificationFrequency){
                if(notificationFrequency.ticked == true){
                    $scope.selectedNotificationFrequency = notificationFrequency.id;
                }
            })
            $scope.newNotificationData.selectedReport = $scope.selectedReport;
            $scope.newNotificationData.selectedProject = $scope.selectedProject;
            $scope.newNotificationData.selectedInfluencerGroup = $scope.selectedInfluencerGroup;
            $scope.newNotificationData.selectedFrequency = $scope.selectedNotificationFrequency;

        } else if($scope.selectedNotificationType == 2){
            angular.forEach($scope.projectList, function(project){
                if(project.ticked == true){
                    $scope.selectedProject = project.id;
                }
            })

            // Influencer Group is not a part of version 1 
            /*angular.forEach($scope.influencerGroupList, function(influencerGroup){
                if(influencerGroup.ticked == true){
                    selectedInfluencerGroup = influencerGroup.id;
                }
            })*/
            
            if($scope.selectedOption == 1){
                $scope.selectedMinValue = $scope.minimumReachList[$scope.selectedRow].value;
            } else if($scope.selectedOption == 2){
                $scope.selectedMinValue = $scope.minimumEngagementList[$scope.selectedRow].value;
            }else if($scope.selectedOption == 3){
                $scope.selectedMinValue = $scope.minimumImpactList[$scope.selectedRow].value;
            } else{
                $scope.selectedMinValue = 1;
            }
            
            $scope.newNotificationData.selectedProject = $scope.selectedProject;
            $scope.newNotificationData.selectedInfluencerGroup = $scope.selectedInfluencerGroup;
            $scope.newNotificationData.minimumConditionType = $scope.selectedOption;
            $scope.newNotificationData.minimumConditionValue = $scope.selectedMinValue;

        } else if($scope.selectedNotificationType == 3){
            $scope.conditionListObject.forEach(function(condition){
                if(condition.match && condition.conditionList && condition.comparision && condition.valueToCompare) {                  
                    var conditionObject = {};
                    condition.match.forEach(function(match){
                        if(match.ticked == true){
                            conditionObject.condition_operator = match.id;
                        }
                    })
                    condition.conditionList.forEach(function(conditionItem){
                        if(conditionItem.ticked == true){
                            conditionObject.condition_type = conditionItem.id;
                        }
                    })
                    condition.comparision.forEach(function(conparisionItem){
                        if(conparisionItem.ticked == true){
                            conditionObject.condition_comparision = conparisionItem.id;
                        }
                    })
                    if(conditionObject.condition_type != 8){
                        condition.valueToCompare.forEach(function(value){
                            if(value.ticked == true){
                                conditionObject.condition_value = value.name;
                            }
                        })
                    } else{
                        conditionObject.condition_value = condition.valueToCompare.name;
                    }
                    $scope.listOfConditions.push(conditionObject);
                }
            })
            $scope.newNotificationData.listOfConditions = $scope.listOfConditions;
        }

        var req = {
            url: $rootScope.apiUrl + 'notification/saveNotification',
            method: 'POST',
            data: JSON.stringify($scope.newNotificationData)
        }

        $http(req).success(function (responseSaveNewNotification) {
            // Mixpanel tracking create notification
            analytics.track(
                TRACK_EVENTS.CREATE_NOTIFICATION.EVT_NAME,
                {
                    "action": "Create",
                    "item": TRACK_EVENTS.CREATE_NOTIFICATION.ITEM_NAME,
                    "target_type": TRACK_EVENTS.CREATE_NOTIFICATION.ITEM_NAME,
                    "target_name": $scope.newNotificationData.notificationName,
                    "params": $scope.newNotificationData
                }
            );
            $modalInstance.close(function () {
                $log.info('Close Modal now');
            })
            var param = {
                advertiser: $scope.selectedAdvertiser
            }
            $scope.loadData(param);  
        })
            .error(function (data) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=07292016',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = data.message;
            });
    }
})

.controller('NotificationDetailCtrl', function ($state, $scope, $modalInstance, $rootScope, $http, $modal, $location, $window, adminService, TRACK_EVENTS) {
    $scope.modalInstance = $modalInstance;
    $scope.isNewNotification = false;
    $scope.notificationTypeDescription = "";
    $scope.selectedNotificationTypeId = 0;
    $scope.selectedRow = null;
    $scope.selectedOption = 0;
    $scope.condition = null;
    $scope.reload = false;
    $scope.countAddedCondition = 0;
    $scope.editRow = true;
    $scope.conditionListObject = [];
    $scope.addNewCondition = false;
    $scope.enableWatch = false;

    var getNotificationTypeUrl = $rootScope.apiUrl + 'notification/getNotificationType';
    $http.get(getNotificationTypeUrl, {loader: false})
    .success(function(responseGetNotificationType){
        $scope.notificationType = responseGetNotificationType.data;
        loadNotificationDetailData();
    }); 

    $scope.cancelAddNewNotification = function() {
        $modalInstance.close();
    }

    $scope.setClickedRow = function(index){
        $scope.selectedRow = index;
    }

    $scope.selectCondition = function(option){ 
        $scope.selectedRow = null;       
        if(option == 'reach'){
            $scope.selectedOption = 1;
            if($scope.selectedOldOption == 1 && $scope.optionValueIndex != null){
                $scope.selectedRow = $scope.optionValueIndex;
            }
        } else if(option == 'engagement'){
            $scope.selectedOption = 2;
            if($scope.selectedOldOption == 2 && $scope.optionValueIndex != null){
                $scope.selectedRow = $scope.optionValueIndex;
            }
        } else if(option == 'impact'){
            $scope.selectedOption = 3;
            if($scope.selectedOldOption == 3 && $scope.optionValueIndex != null){
                $scope.selectedRow = $scope.optionValueIndex;
            }
        } else if(option == 'none'){
            $scope.selectedOption = 0;
        }
    }

    $scope.addCondition = function(){
        var match = null;
        var conditionList = null;
        var newCondition = {};

        var getMatchUrl = $rootScope.apiUrl + 'notification/getMatch';
        $http.get(getMatchUrl, {loader: false})
        .success(function(responseGetMatch){
            newCondition.match = responseGetMatch.data;
            newCondition.match[0].ticked = true;

            var getConditionListUrl = $rootScope.apiUrl + 'notification/getConditionList';
            $http.get(getConditionListUrl, {loader: false})
            .success(function(responseGetConditionList){
                newCondition.conditionList = responseGetConditionList.data;
                $scope.conditionListObject.push(newCondition);
                $scope.reload = false;
                $scope.addNewCondition = true;
            });
        });                
    }

    $scope.removeCondition = function(index){
        $scope.conditionListObject.splice(index, 1);
        $scope.countAddedCondition = 0;
        $scope.reload = true;
        $scope.editRow = false;
        $scope.addNewCondition = false;
        $scope.enableWatch = true;
    }
    $scope.updateReload = function(){
        $scope.reload = !$scope.updateReload;
        $scope.enableWatch = false;
    }

    function loadNotificationDetailData(){
        $scope.notificationTypeDescription = "";
        $scope.conditionListObject = [];
        var getNotificationByIdUrl = $rootScope.apiUrl + 'notification/getNotificationById/' + $scope.notificationId;
        $http.get(getNotificationByIdUrl, {loader: false})
            .success(function(responseGetNotificationById){
                $scope.notificationName = responseGetNotificationById.data.name;
                $scope.selectedNotificationTypeId = responseGetNotificationById.data.notification_type;
                $scope.selectedNotificationDetailTypeId = responseGetNotificationById.data.notification_type;
                $scope.selectedNotificationFrequency = responseGetNotificationById.data.notification_frequency;
                $scope.selectedProject = responseGetNotificationById.data.project_id;
                $scope.selectedInfluencerGroup = responseGetNotificationById.data.influencer_group;

                if($scope.selectedAdvertiser != 0) {
                    var url = $rootScope.apiUrl + 'notification/getUserByCompany/' + $scope.selectedAdvertiser;
                    $http.get(url, {loader: false}).
                        success(function (response) {
                            $scope.userList = response.data;
                            $scope.userList.forEach(function(user) {
                                if(user.id == responseGetNotificationById.data.user_id) {
                                    user.ticked = true;
                                } else {
                                    user.ticked = false;
                                }
                            })
                        }).error(function (response) {
                            $scope.userList = [];
                        });
                } 

                $scope.notificationType.forEach(function(notification){
                    if(notification.id == $scope.selectedNotificationTypeId){
                        notification.ticked = true;
                    }
                })

                if($scope.selectedNotificationTypeId == 1){                    
                    $scope.notificationTypeDescription = 'Get weekly or monthly report on your project';
                    var getReportTypeUrl = $rootScope.apiUrl + 'notification/getMeasureReportType/' + $scope.selectedAdvertiser;
                    $http.get(getReportTypeUrl, {loader: false})
                    .success(function(responseGetReportType){
                        $scope.reportList = responseGetReportType.data;

                        var getNotificationFrequencyUrl = $rootScope.apiUrl + 'notification/getNotificationFrequency';
                        $http.get(getNotificationFrequencyUrl, {loader: false})
                        .success(function(responseGetNotificationFrequency){
                            $scope.notificationFrequencyList = responseGetNotificationFrequency.data;
                            $scope.notificationFrequencyList.splice(0,1);
                            $scope.notificationFrequencyList.forEach(function(frequency){
                                if(frequency.id == $scope.selectedNotificationFrequency){
                                    frequency.ticked = true;
                                }
                            })

                            var getNotificationProjectUrl = $rootScope.apiUrl + 'notification/getProject/' + $scope.selectedAdvertiser;
                            $http.get(getNotificationProjectUrl, {loader: false})
                            .success(function(responseGetNotificationProject){
                                $scope.projectList = responseGetNotificationProject.data;
                                $scope.projectList.forEach(function(project){
                                    project.name = project.project_name;
                                    if(project.id == $scope.selectedProject){
                                        project.ticked = true;
                                    }
                                })
                                
                                var getNotificationReportTypetUrl = $rootScope.apiUrl + 'notification/getNotificationReportType/' + $scope.notificationId;
                                $http.get(getNotificationReportTypetUrl, {loader: false})
                                .success(function(responseGetNotificationReportType){
                                    $scope.reportList.forEach(function(report){
                                        if(report.id == responseGetNotificationReportType.data.report_id){
                                            report.ticked = true;
                                        }
                                    })                            
                                })
                            })
                        });
                    }); 
                } else if($scope.selectedNotificationTypeId == 2){
                    $scope.notificationTypeDescription = 'Get notification when your brands get mentioned';
                    var getNotificationProjectUrl = $rootScope.apiUrl + 'notification/getProject/' + $scope.selectedAdvertiser;
                    $http.get(getNotificationProjectUrl, {loader: false})
                    .success(function(responseGetNotificationProject){
                        $scope.projectList = responseGetNotificationProject.data;
                        $scope.projectList.forEach(function(project){
                            project.name = project.project_name;
                            if(project.id == $scope.selectedProject){
                                project.ticked = true;
                            }
                        })
                        var getNotificationMinimumConditionUrl = $rootScope.apiUrl + 'notification/getNotificationMinimumCondition/' + $scope.notificationId;
                        $http.get(getNotificationMinimumConditionUrl, {loader: false})
                        .success(function(responseGetNotificationMinimumCondition){
                            if(responseGetNotificationMinimumCondition.data.none_criteria == 0){
                                if(responseGetNotificationMinimumCondition.data.min_reach != null){
                                    $scope.selectedOption = 1;
                                    $scope.selectedOldOption = 1;
                                    angular.forEach($scope.editMinReachList, function(reach){
                                        if(reach.value == responseGetNotificationMinimumCondition.data.min_reach){
                                            $scope.optionValueIndex = $scope.minimumReachList.indexOf(reach);
                                            $scope.selectedRow = $scope.minimumReachList.indexOf(reach);
                                        }
                                    })
                                    $scope.minimumReachList = $scope.editMinReachList;
                                } else if(responseGetNotificationMinimumCondition.data.min_engagement != null){
                                    $scope.selectedOption = 2;
                                    $scope.selectedOldOption = 2;
                                    angular.forEach($scope.editMinEngagementList, function(engagement){
                                        if(engagement.value == responseGetNotificationMinimumCondition.data.min_engagement){
                                            $scope.optionValueIndex = $scope.minimumEngagementList.indexOf(engagement);
                                            $scope.selectedRow = $scope.minimumEngagementList.indexOf(engagement);
                                        }
                                    })
                                    $scope.minimumEngagementList = $scope.editMinEngagementList;
                                } else if(responseGetNotificationMinimumCondition.data.min_impact != null){
                                    $scope.selectedOption = 3;
                                    $scope.selectedOldOption = 3;
                                    angular.forEach($scope.editMinImpactList, function(impact){
                                        if(impact.value == responseGetNotificationMinimumCondition.data.min_impact){
                                            $scope.optionValueIndex = $scope.minimumImpactList.indexOf(impact);
                                            $scope.selectedRow = $scope.minimumImpactList.indexOf(impact);
                                        }
                                    })
                                    $scope.minimumImpactList = $scope.editMinImpactList;
                                }
                            } else{
                                $scope.selectedRow = null;
                                $scope.selectedOption = 0;
                            }                             
                        })
                    })
                } else if($scope.selectedNotificationTypeId == 3){
                    $scope.selectedNotificationTypeId = 3;
                    $scope.notificationTypeDescription = 'Get notification for relevant influencers for your brand';                    
                    var getNotificationConditionListtUrl = $rootScope.apiUrl + 'notification/getNotificationConditionList/' + $scope.notificationId;
                    $http.get(getNotificationConditionListtUrl, {loader: false})
                    .success(function(responseGetNotificationConditionList){
                        $scope.conditionListObject = responseGetNotificationConditionList.data;
                    })
                }
            })
    }

    $scope.selectNotificationType = function(data){
        if(data.id == 1){
            if($scope.selectedNotificationDetailTypeId == 1){
                loadNotificationDetailData();
            } else{
                $scope.selectedNotificationTypeId = 1;
                $scope.notificationTypeDescription = 'Get weekly or monthly report on your project';
                var getReportTypeUrl = $rootScope.apiUrl + 'notification/getMeasureReportType/' + $scope.selectedAdvertiser;
                $http.get(getReportTypeUrl, {loader: false})
                .success(function(responseGetReportType){
                    $scope.reportList = responseGetReportType.data;

                    var getNotificationFrequencyUrl = $rootScope.apiUrl + 'notification/getNotificationFrequency';
                    $http.get(getNotificationFrequencyUrl, {loader: false})
                    .success(function(responseGetNotificationFrequency){
                        $scope.notificationFrequencyList = responseGetNotificationFrequency.data;
                        $scope.notificationFrequencyList.splice(0,1);

                        var getNotificationProjectUrl = $rootScope.apiUrl + 'notification/getProject/' + $scope.selectedAdvertiser;
                        $http.get(getNotificationProjectUrl, {loader: false})
                        .success(function(responseGetNotificationProject){
                            $scope.projectList = responseGetNotificationProject.data;
                            $scope.projectList.forEach(function(project){
                                project.name = project.project_name;
                            })
                            
                        })
                    });
                });
            }
        } else if(data.id == 2){
            if($scope.selectedNotificationDetailTypeId == 2){
                loadNotificationDetailData();
            } else{
                $scope.selectedNotificationTypeId = 2;
                $scope.notificationTypeDescription = 'Get notification when your brands get mentioned';
                var getNotificationProjectUrl = $rootScope.apiUrl + 'notification/getProject/' + $scope.selectedAdvertiser;
                $http.get(getNotificationProjectUrl, {loader: false})
                .success(function(responseGetNotificationProject){
                    $scope.projectList = responseGetNotificationProject.data;
                    $scope.projectList.forEach(function(project){
                        project.name = project.project_name;
                    })                    
                })
            }
        } else if(data.id == 3){
            if($scope.selectedNotificationDetailTypeId == 3){
                loadNotificationDetailData();
            } else{
                $scope.selectedNotificationTypeId = 3;
                $scope.notificationTypeDescription = 'Get notification for relevant influencers for your brand';
            }
        }
    }

    $scope.updateNotification = function(){        
        $scope.selectedNotificationType = 0;
        $scope.selectedReport = null;
        $scope.selectedProject = null;
        $scope.selectedInfluencerGroup = null;
        $scope.selectedNotificationFrequency = null;
        $scope.selectedMinValue = 0;
        $scope.listOfConditions = [];

        angular.forEach($scope.notificationType, function(noType){
            if(noType.ticked == true){
                $scope.selectedNotificationType = noType.id;
            }
        })

        $scope.updateNotificationData = {
            notificationId: $scope.notificationId,
            notificationName: $scope.notificationName,
            notificationType: $scope.selectedNotificationType
        };

        $scope.updateNotificationData.selectedAdvertiser = $scope.selectedAdvertiser;
        if($scope.updateNotificationData.selectedAdvertiser != 0) {
            $scope.updateNotificationData.selectedUser = $scope.selectedUser[0].id;
        }

        if($scope.selectedNotificationType == 1){
            angular.forEach($scope.reportList, function(report){
                if(report.ticked == true){
                    $scope.selectedReport = report.id;
                }
            })

            angular.forEach($scope.projectList, function(project){
                if(project.ticked == true){
                    $scope.selectedProject = project.id;
                }
            })

            // Influencer Group is not a part of version 1 
            /*angular.forEach($scope.influencerGroupList, function(influencerGroup){
                if(influencerGroup.ticked == true){
                    selectedInfluencerGroup = influencerGroup.id;
                }
            })*/

            angular.forEach($scope.notificationFrequencyList, function(notificationFrequency){
                if(notificationFrequency.ticked == true){
                    $scope.selectedNotificationFrequency = notificationFrequency.id;
                }
            })
            $scope.updateNotificationData.selectedReport = $scope.selectedReport;
            $scope.updateNotificationData.selectedProject = $scope.selectedProject;
            $scope.updateNotificationData.selectedInfluencerGroup = $scope.selectedInfluencerGroup;
            $scope.updateNotificationData.selectedFrequency = $scope.selectedNotificationFrequency;

        } else if($scope.selectedNotificationType == 2){
            angular.forEach($scope.projectList, function(project){
                if(project.ticked == true){
                    $scope.selectedProject = project.id;
                }
            })

            // Influencer Group is not a part of version 1 
            /*angular.forEach($scope.influencerGroupList, function(influencerGroup){
                if(influencerGroup.ticked == true){
                    selectedInfluencerGroup = influencerGroup.id;
                }
            })*/

            if($scope.selectedOption == 1){
                $scope.selectedMinValue = $scope.minimumReachList[$scope.selectedRow] ? $scope.minimumReachList[$scope.selectedRow].value : null;
            } else if($scope.selectedOption == 2){
                $scope.selectedMinValue = $scope.minimumEngagementList[$scope.selectedRow] ? $scope.minimumEngagementList[$scope.selectedRow].value : null;
            }else if($scope.selectedOption == 3){
                $scope.selectedMinValue = $scope.minimumImpactList[$scope.selectedRow] ? $scope.minimumImpactList[$scope.selectedRow].value : null;
            } else{
                $scope.selectedMinValue = 1;
            }
            
            $scope.updateNotificationData.selectedProject = $scope.selectedProject;
            $scope.updateNotificationData.selectedInfluencerGroup = $scope.selectedInfluencerGroup;
            $scope.updateNotificationData.minimumConditionType = $scope.selectedOption;
            $scope.updateNotificationData.minimumConditionValue = $scope.selectedMinValue;

        } else if($scope.selectedNotificationType == 3){
            $scope.conditionListObject.forEach(function(condition){               
               if(condition.match && condition.conditionList && condition.comparision && condition.valueToCompare) {                  
                    var conditionObject = {};
                    condition.match.forEach(function(match){
                        if(match.ticked == true){
                            conditionObject.condition_operator = match.id;
                        }
                    })
                    condition.conditionList.forEach(function(conditionItem){
                        if(conditionItem.ticked == true){
                            conditionObject.condition_type = conditionItem.id;
                        }
                    })
                    condition.comparision.forEach(function(conparisionItem){
                        if(conparisionItem.ticked == true){
                            conditionObject.condition_comparision = conparisionItem.id;
                        }
                    })
                    if(conditionObject.condition_type != 8){
                        condition.valueToCompare.forEach(function(value){
                            if(value.ticked == true){
                                conditionObject.condition_value = value.name;
                            }
                        })
                    } else{
                        conditionObject.condition_value = condition.valueToCompare.name;
                    }
                    $scope.listOfConditions.push(conditionObject);
                }
            })
            $scope.updateNotificationData.listOfConditions = $scope.listOfConditions;
        }

        var req = {
            url: $rootScope.apiUrl + 'notification/updateNotification',
            method: 'POST',
            data: JSON.stringify($scope.updateNotificationData)
        }

        $http(req).success(function (responseupdateNotification) {
            // Mixpanel tracking update notification
            analytics.track(
                TRACK_EVENTS.UPDATE_NOTIFICATION.EVT_NAME,
                {
                    "action": "Update",
                    "item": TRACK_EVENTS.UPDATE_NOTIFICATION.ITEM_NAME,
                    "target_type": TRACK_EVENTS.UPDATE_NOTIFICATION.ITEM_NAME,
                    "target_name": $scope.updateNotificationData.notificationName,
                    "target_id": $scope.updateNotificationData.notificationId,
                    "params": $scope.updateNotificationData
                }
            );

            $modalInstance.close(function () {
                $log.info('Close Modal now');
            })
            var param = {
                advertiser: $scope.selectedAdvertiser
            }
            $scope.loadData(param);  
        })
            .error(function (data) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=07292016',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = data.message;
            });
    }
})